export enum FEATURE_FLAGS {
    SpellingGrammarMetrics = "spelling_grammar_metrics",
    GrammarMetric = "grammar_metric",
    WritingIssuesFilter = "writing_issues_filter",
    CustomizableExploreCharts = "customizable_explore_charts",
    ScorecardsAgentsLogin = "scorecards_agents_login",
    AgentsTableRefactor = "agents_table_refactor",
    EmpathySentiment = "empathy_sentiment",
    ConfusionSentiment = "confusion_sentiment",
    InteractionGroupSummary = "interaction_group_summary",
    NewMetricDistributionSelector = "new_metric_distribution_selector",
    InternalFeatureFlagToggler = "internal_feature_flag_toggler",
    CustomerOverview = "customer_overview",
    CustomizableExploreChartsTotals = "customizable_explore_charts_totals",
    NewInteractionCountPercentageMetric = "new_interaction_count_percentage_metric",
    ReviewStatusFilter = "review_status_filter",
    ReviewerFilter = "reviewer_filter",
    InteractionAgentPerformanceSummary = "interaction_agent_performance_summary",
    ReviewSectionInInteraction = "review_section_in_interaction",
    OlapPhraseTriggerCounts = "olap_phrase_trigger_counts",
    InteractionTableReviewStatusMetric = "interaction_table_review_status_metric",
    AddReviewMetricsToChartsAndTables = "add_review_metrics_to_charts_and_tables",
    FilterPresetsPhase2 = "filter_presets_phase2",
    FrequentCustomersScreen = "frequent_customers_screen",
    HideMetricOverTimeCharts = "hide_metric_over_time_charts",
    EditCompletedReviews = "edit_completed_reviews",
    HomeScreen = "home_screen",
}
